var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSend = function SvgSend(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2899 0.721973C12.9565 0.379716 12.4629 0.252209 12.0027 0.386427L1.27167 3.507C0.78614 3.64189 0.441999 4.02911 0.349295 4.52102C0.254589 5.02165 0.585391 5.65718 1.01757 5.92293L4.37294 7.98519C4.71708 8.19658 5.16126 8.14357 5.44605 7.85634L9.28829 3.99019C9.4817 3.78886 9.80183 3.78886 9.99524 3.99019C10.1887 4.1848 10.1887 4.50022 9.99524 4.70154L6.14633 8.56837C5.86088 8.85492 5.80753 9.3012 6.01762 9.64748L8.06779 13.0365C8.30789 13.4391 8.72139 13.6673 9.17491 13.6673C9.22826 13.6673 9.28829 13.6673 9.34164 13.6606C9.86186 13.5935 10.2754 13.2378 10.4288 12.7345L13.6101 2.01718C13.7501 1.56084 13.6234 1.06423 13.2899 0.721973Z",
    fill: "#5547DD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Send.2069ebc0259620f15d64d045bc80b4c0.svg";